export default {
      id: "150,1=1,7+120+28,4-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#150,1=1,7+120+28,4",
      toString: function () {
        return this.url;
      }
    }